import React from "react";
import { Col, Row } from "react-bootstrap";
import chatgpt from "../../Assets/chatgpt.png";
import claude from "../../Assets/claude.png";
import grok from "../../Assets/grok.png";
import notebook from "../../Assets/notebook.png";
import quillbot from "../../Assets/quillbot.png";



function AIBOTS() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons" title="chatgpt">
        <img className="depimage" src={chatgpt} alt="chatgpt"/>
      </Col>

       <Col xs={4} md={2} className="tech-icons" title="claude">
        <img className="depimage" src={claude} alt="claude"/>
      </Col>

       <Col xs={4} md={2} className="tech-icons" title="grok">
        <img className="depimage" src={grok} alt="grok"/>
      </Col>

       <Col xs={4} md={2} className="tech-icons" title="notebook">
        <img className="depimage" src={notebook} alt="notebook"/>
      </Col>

      <Col xs={4} md={2} className="tech-icons" title="quillbot">
        <img className="depimage" src={quillbot} alt="quillbot"/>
      </Col>
      
  
    </Row>
  );
}

export default AIBOTS;
